module.exports = __webpack_public_path__ + "static/media/castelFromSky.d79bee72.png";